import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Stack } from '@mui/material';
import DrawerHeaderStyled from './DrawerHeaderStyled';
import logo from 'assets/images/users/aaLogo.png'
import logoCircle from 'assets/images/users/favicon.ico'
import { Link } from 'react-router-dom';


const DrawerHeader = ({ open }) => {
  const role = localStorage.getItem("ROLE");
  const getDashboardPath = () => {
    switch (role) {
      case "Finance":
        return "/finance_dashboard";

      case "Admin":
        return "/";

      case "Network":
        return "/";

      default:
        return "/";
    }
  };
  const theme = useTheme();

  return (
    <DrawerHeaderStyled theme={theme} open={open} style={{ paddingLeft: "0px" }}>
      <Stack spacing={1} alignItems="center" justifyContent="center">
        <Link to={getDashboardPath()}>
          {open ?
            <img alt="logo" src={logo} width="190px" style={{ cursor: 'pointer' }} />
            :
            <img alt="logo" src={logoCircle} width="40px" style={{ cursor: 'pointer' }} />
          }
        </Link>
      </Stack>
    </DrawerHeaderStyled>
  );
};

DrawerHeader.propTypes = {
  open: PropTypes.bool
};

export default DrawerHeader;
